(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  // Simple sticky header that works on all pages
  document.addEventListener('DOMContentLoaded', function() {
    const stickyNav = document.querySelector('.header-navigation-sticky');
    const headerWrapper = document.querySelector('.header-wrapper');
    
    if (!stickyNav || !headerWrapper) return;

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerRect = headerWrapper.getBoundingClientRect();
      const headerBottom = scrollTop + headerRect.bottom;
      
      if (scrollTop > headerBottom - headerRect.height) {
        stickyNav.style.opacity = '1';
        stickyNav.style.visibility = 'visible';
        stickyNav.style.transform = 'translateY(0)';
      } else {
        stickyNav.style.opacity = '0';
        stickyNav.style.visibility = 'hidden';
        stickyNav.style.transform = 'translateY(-100%)';
      }
    }

    window.addEventListener('scroll', handleScroll);
    // Initial call to set correct state
    handleScroll();
  });

  } catch(e) { console.error(e); }
})();
})();
